/**
 * Created by zzy on 2019/8/5.
 */
import EnvironmentMonitoring from './EnvironmentMonitoring.vue'
export default EnvironmentMonitoring



// WEBPACK FOOTER //
// ./src/views/monitoring/environmentMonitoring/index.js